"use client";

import {Globe, Check} from "lucide-react";
import {cn} from "@/lib/utils";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface LocaleLink {
    code: string;
    displayName: string;
    direction: "ltr" | "rtl";
    href: string;
}

interface LanguageSwitcherProps {
    currentLocale: string;
    localeLinks: LocaleLink[];
    label: string;
    ariaLabel: string;
    className?: string;
}

export function LanguageSwitcher({currentLocale, localeLinks, label, ariaLabel, className}: LanguageSwitcherProps) {
    const currentDisplayName =
        localeLinks.find((l) => l.code === currentLocale)?.displayName ?? currentLocale;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                aria-label={ariaLabel}
                className={cn("inline-flex items-center gap-2 rounded-md border bg-muted px-3 py-2 text-sm font-medium shadow-xs outline-none hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50", className)}
            >
                <Globe className="h-4 w-4" />
                <span className="hidden sm:inline">{label}</span>
                <span className="hidden xxs:inline">{currentDisplayName}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {localeLinks.map((locale) => (
                    <DropdownMenuItem key={locale.code} asChild>
                        <a href={locale.href} dir={locale.direction}>
                            <Check
                                className={`me-2 h-4 w-4 ${
                                    locale.code === currentLocale ? "opacity-100" : "opacity-0"
                                }`}
                            />
                            {locale.displayName}
                        </a>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
